// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar_MCiTTporB_OYViughBpC::-webkit-scrollbar {
  width: 1.125rem;
}

.scrollbar_MCiTTporB_OYViughBpC::-webkit-scrollbar-track {
  border-radius: 0.625rem;
  background: var(--hc-color-neutral-0);
}

.scrollbar_MCiTTporB_OYViughBpC::-webkit-scrollbar-thumb {
  border-radius: 0.625rem;
  background-color: var(--hc-color-neutral-200);
  border: 6px solid var(--hc-color-neutral-0);
}

/* Firefox */
@-moz-document url-prefix() {
  .scrollbar_MCiTTporB_OYViughBpC {
    scrollbar-width: thin;
    scrollbar-color: var(--hc-color-neutral-200) transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/contentList/components/moduleCard/showClasses/showClasses.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE;IACE,qBAAqB;IACrB,wDAAwD;EAC1D;AACF","sourcesContent":[".scrollbar::-webkit-scrollbar {\n  width: 1.125rem;\n}\n\n.scrollbar::-webkit-scrollbar-track {\n  border-radius: 0.625rem;\n  background: var(--hc-color-neutral-0);\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 0.625rem;\n  background-color: var(--hc-color-neutral-200);\n  border: 6px solid var(--hc-color-neutral-0);\n}\n\n/* Firefox */\n@-moz-document url-prefix() {\n  .scrollbar {\n    scrollbar-width: thin;\n    scrollbar-color: var(--hc-color-neutral-200) transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var scrollbar = `scrollbar_MCiTTporB_OYViughBpC`;
export default ___CSS_LOADER_EXPORT___;
